import Chart from "chart.js";

let configured = false;

export function configureChartFont(family = "IRANSans") {
  if (configured) return;

  if (Chart.defaults.global) {
    Chart.defaults.global.defaultFontFamily = family;
  } else if (Chart.defaults.font) {
    Chart.defaults.font.family = family;
  }

  configured = true;
}
